import { useVideoConferenceContext } from '../../hooks';
import { Users } from 'lucide-react';
import classes from '../ControlBar/ControlBar.module.css';

export const ParticipantsButton = () => {
  const { toggleParticipants, extendedWidgetState } = useVideoConferenceContext();

  return (
    <button
      type="button"
      aria-label="Participants"
      aria-pressed={extendedWidgetState.showParticipants}
      onClick={toggleParticipants}
      className={`lk-button ${classes.button}`}
    >
      <Users size={20} />
    </button>
  );
};
